const ENTORNO = 'production';

const local = {
    url: 'http://localhost',
    port: '3030'
}
const production = {
    url: 'https://discover.xertux.com'
}

export function getServerURL() {
    switch (ENTORNO) {
        case 'local':
            return `${local.url}:${local.port}/api/`;
        case 'production':
            return `${production.url}/api/`;
        default:
            return `${local.url}:${local.port}/api/`;
    }
}
